import { combineReducers } from "redux";
import UserReducer from "./UserReducer";
import MenuReducer from "./MenuReducer";

const rootReducer = combineReducers({
  UserReducer,
  MenuReducer,
});
export default rootReducer;
